import { CourseReportFilterI } from 'types';
import { z } from 'zod';

export const coursesReportsSchema = z.object({
  name: z.string().optional(),
  prioritiesId: z.string().optional(),
});

export const defaultValues: CourseReportFilterI = {
  name: undefined,
  prioritiesId: undefined,
};
